import * as api from '@/api'

export default {
  async generateExplanation(payload) {
    let result = {}

    try {
      result = await api.openai.generateExplanation(payload)
    } catch (error) {
      console.error(error)
    }

    return result
  }
}
